export const REQUEST_PROFILE_TAB_DOC_FLOWS_ACTION_DISCONNECT = 'disconnect'

export const REQUEST_PROFILE_TAB_DOC_FLOWS_BUTTON_TEXT_KEY = {
  connect: 'RequestProfile.DocFlowsConnectBtnKey',
  create: 'RequestProfile.DocFlowsCreateBtnKey',
}

export const REQUEST_PROFILE_TAB_DOC_FLOWS_FILTER_BAR_ITEMS_PROPS = {
  SaveTemplateButton: null,
  ShareTemplateButton: null,
}

export const REQUEST_PROFILE_TAB_DOC_FLOWS_QA_NAME = {
  connect: 'requestProfileTabDocFlowsConnect',
  create: 'requestProfileTabDocFlowsCreate',
  emptyConnect: 'requestProfileTabDocFlowsEmptyConnect',
  emptyCreate: 'requestProfileTabDocFlowsEmptyCreate',
  search: 'requestProfileTabDocFlowsSearch',
}

export const REQUEST_PROFILE_TAB_DOC_FLOWS_SEARCH_FILTER_KEY = 'search'

export const REQUEST_PROFILE_TAB_DOC_FLOWS_SEARCH_HEIGHT = 32

export const REQUEST_PROFILE_TAB_DOC_FLOWS_SEARCH_MAX_LENGTH = 256

export const REQUEST_PROFILE_TAB_DOC_FLOWS_SEARCH_TIMEOUT = 300
